module.exports = __webpack_public_path__ + "static/img/包裝-洪詩儀.ec526cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/包裝-洪詩儀.jpg
// module id = e2ey
// module chunks = 1